import { Action } from "../types";
import { ModalAction } from "./actions";
import { ModalState } from "./types";

const initial_modal: ModalState = {
  header: undefined,
  content: undefined,
  onClose: undefined,
  onAccept: undefined,
  customButtons: undefined,
  cancelButtonLabel: undefined,
  acceptButtonLabel: undefined
}

const modalReducer = (state = initial_modal, action: Action): ModalState => {
  const { data, type } = action ?? {}
  switch (type) {
    case ModalAction.CLOSE_MODAL:
      return initial_modal
      break

    case ModalAction.UPDATE_MODAL:
      return {
        ...state,
        ...data
      }
      break

    default:
      return state
  }
}

export { modalReducer, initial_modal }
